// ** MUI Imports
import styled from "@emotion/styled";
import { Grid } from "@mui/material";
import Box from "@mui/material/Box";
import MuiLink from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import Image from "next/image";
import Link from "next/link";
import clsx from "clsx";
import { useRouter } from "next/router";
import { Icon } from "@iconify/react";

import { Mail, Location, Phone } from "src/icons/core";
import { Instagram, Linkedin, Telegram, Twitter } from "src/icons/socials";

const TermsTypography = styled(Typography)(({ theme }) => ({
  lineHeight: 2,
}));

const FooterLink = styled(Link)(({ theme }) => ({
  color: "white",
  "&.active": {
    color: theme.palette.primary.main,
  },
}));

const FooterContent = () => {
  const router = useRouter();

  const handleClickOpen = () => {
    window.open(
      "https://logo.samandehi.ir/Verify.aspx?id=319584&p=xlaorfthpfvldshwmcsiaods",
      "Popup",
      "toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30"
    );
  };
  return (
    <Box>
      <Grid container spacing={5} justifyContent={"space-between"}>
        <Grid item xs={12} lg={5}>
          <Image
            src="/images/logo/logo.svg"
            alt="logo img"
            width={80}
            height={40}
            unoptimized={true}
          />
          <TermsTypography
            variant="body1"
            textAlign={"justify"}
            color="secondary.dark"
            sx={{ fontWeight: 500 }}
          >
            «موزونو» مسیر ارتباطی بین مشتریان ایرانی با برندهای جهانی است. خرید
            از آمازون امارات با موزونو این اطمینان را به شما می‌دهد که بهترین
            قیمت و سریع‌ترین زمان تحویل را در کنار اورجینال بودن کالاها تجربه
            کنید. هدف موزونو تسهیل سفارش از آمازون با بهترین قیمت برای شما است.
          </TermsTypography>

          <Box display={"flex"} alignItems={"center"} mt={10} gap={7}>
            <FooterLink
              href="https://instagram.com/mozono.ir?igshid=YmMyMTA2M2Y="
              passHref={true}
              target="_blank"
            >
              <Icon icon="tabler:brand-instagram" fontSize={40} color="white" />
            </FooterLink>

            <FooterLink
              href="https://www.linkedin.com/company/mozono/"
              passHref={true}
              target="_blank"
            >
              <Icon icon="tabler:brand-linkedin" fontSize={40} color="white" />
            </FooterLink>

            <FooterLink
              href="https://t.me/+-hhFXt4qvWIxYjhk"
              passHref={true}
              target="_blank"
            >
              <Icon icon="tabler:brand-telegram" fontSize={40} color="white" />
            </FooterLink>

            <FooterLink
              href="https://instagram.com/mozono.ir?igshid=YmMyMTA2M2Y="
              passHref={true}
              target="_blank"
            >
              <Icon icon="tabler:brand-twitter" fontSize={40} color="white" />
            </FooterLink>
          </Box>

          <Box display={"flex"} mt={5}>
            <a
              referrerpolicy="origin"
              target="_blank"
              href="https://trustseal.enamad.ir/?id=300312&amp;Code=pAUHbo1o3cHjQSYg87ME"
              // style={{ width: 100, height: 100, backgroundColor: 'white' }}
            >
              <Image
                referrerpolicy="origin"
                src="/images/enamad-1.png"
                alt="enamad"
                width={100}
                height={100}
                style={{ backgroundColor: "white" }}
                className="cursor-pointer width-100 height-100 "
              />
            </a>
            <Image
              className="cursor-pointer ms-2"
              referrerpolicy="origin"
              id="rgvjjxlzsizpapfuoeukwlao"
              onClick={handleClickOpen}
              width={100}
              height={100}
              style={{
                cursor: "pointer",
                marginRight: 20,
              }}
              alt="logo-samandehi"
              src="/images/samandehi.jpeg"
            />
          </Box>
        </Grid>
        <Grid item xs={12} lg={2}>
          <Typography variant="h4" color="white">
            صفحات
          </Typography>
          <Box mt={7}>
            <FooterLink
              className={clsx({ active: router.pathname === "/" })}
              href="/"
            >
              خانه
            </FooterLink>
          </Box>
          <Box mt={3}>
            <FooterLink
              className={clsx({ active: router.pathname === "/blog" })}
              href="/blog"
            >
              بلاگ
            </FooterLink>
          </Box>
          <Box mt={3}>
            <FooterLink
              className={clsx({ active: router.pathname === "/terms" })}
              href="/terms"
            >
              قوانین و مقررات
            </FooterLink>
          </Box>

          <Box my={3}>
            <FooterLink
              className={clsx({ active: router.pathname === "/contactus" })}
              href="/contactus"
            >
              تماس باما
            </FooterLink>
          </Box>

          <Box>
            <FooterLink
              href="https://amazon.ae"
              passHref={true}
              target="_blank"
            >
              آمازون امارات
            </FooterLink>
          </Box>
        </Grid>
        <Grid item xs={12} lg={3}>
          <Typography variant="h4" color="white">
            ارتباط با ما
          </Typography>
          <Box display={"flex"} alignItems={"center"} color={"white"} mt={7}>
            <Phone />
            <Typography variant="body1" color="white" ml={5}>
              02191031644
            </Typography>
          </Box>
          <Box display={"flex"} alignItems={"center"} color={"white"} my={3}>
            <Mail />
            <Typography variant="body1" color="white" ml={5}>
              info@mozono.ir
            </Typography>
          </Box>
          <Box display={"flex"} alignItems={"center"} mt={3} mb={7}>
            {/* <Icon icon='tabler:map-pin-filled' fontSize={50} color='white' /> */}
            <Typography variant="body1" color="white">
              دفتر مرکزی :‌ شیراز - بلوار فضیلت - نبش کوچه ۱۷ - ساختمان اداری
              سام سنتر - طبقه ۳ - واحد ۷
              <br />
              <br />
              شعبه فروش حضوری : شیراز - خیابان عفیف آباد - مجتمع تجاری تفریحی
              عفیف آباد - طبقه منفی یک - پلاک ۱۲
              <br />
              <br />
              انبار مرکزی :‌ فارس - گله دار خیابان امام خمینی - انبار مرکزی
              موزونو
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default FooterContent;
